import { useEffect } from "react";
import { MixpanelWrapper } from "../MixPanelWrapper";
import QuotesTab from "../Tabs/quotesTab";

/**
 * Component for rendering the QuotesTab.
 * This component tracks the "Quotes Page" event with Mixpanel.
 * @returns {JSX.Element} - The rendered component.
 */
const QuotesPage = () => {
	useEffect(() => {
		// Track the "Quotes Page" event with Mixpanel when the component mounts.
		MixpanelWrapper.track("Quotes Page");
	}, []);

	return <QuotesTab createQuoteButton={true} />;
};

export default QuotesPage;
